import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const MapsMarkerHeart = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-maps-marker-heart',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.mapsMarkerHeart.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      fill={color}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="m11.9948 2a7.6186 7.6186 0 0 0 -7.7726 7.4107c0 5.21 5.2446 10.6509 6.7971 12.201a1.4326 1.4326 0 0 0 1.9614 0c1.5944-1.55 6.7971-7.0006 6.7971-12.201a7.6192 7.6192 0 0 0 -7.783-7.4107zm.0052 10.5882a2.9922 2.9922 0 0 1 -2.7646-1.8182 2.9054 2.9054 0 0 1 .6528-3.206 3.029 3.029 0 0 1 3.2633-.6314 2.9339 2.9339 0 0 1 -1.1515 5.6556z"
      />
      <path
        fill={secondColor}
        d="m12 12.5882a2.9922 2.9922 0 0 1 -2.7646-1.8182 2.9054 2.9054 0 0 1 .6528-3.206 3.029 3.029 0 0 1 3.2633-.6314 2.9339 2.9339 0 0 1 -1.1515 5.6556z"
      />
      <path
        fill={theme.palette.color8.hex}
        d="m19.097 4.0965a1.3909 1.3909 0 0 0 -1.3537-1.5524 1.2941 1.2941 0 0 0 -1.1781.8467 1.2993 1.2993 0 0 0 -1.1915-.8467 1.3783 1.3783 0 0 0 -1.33 1.5524c0 1.9 2.2711 2.9392 2.5212 2.9392s2.5321-1.0368 2.5321-2.9392z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="m17.7433 2h-.0124a1.8176 1.8176 0 0 0 -1.1665.457 1.8211 1.8211 0 0 0 -1.1826-.457 1.909 1.909 0 0 0 -1.8818 2.0965c0 2.2711 2.5665 3.4833 3.0654 3.4833.5006 0 3.0759-1.2122 3.0759-3.4833a1.9385 1.9385 0 0 0 -1.898-2.0965zm-3.6993 2.0965a1.3783 1.3783 0 0 1 1.33-1.5524 1.2993 1.02993 0 0 1 1.1915.8467 1.2941 1.2941 0 0 1 1.1781-.8467 1.3909 1.3909 0 0 1 1.3534 1.5524c0 1.9024-2.2819 2.9392-2.5318 2.9392s-2.5212-1.0395-2.5212-2.9392z"
      />
    </IconSvg>
  );
};

export default memo(MapsMarkerHeart);
